import { Component, Input, OnInit } from '@angular/core';
import { OrderModel } from 'src/app/models/order.model';
import { ProductModel } from 'src/app/models/product.model';
import { TourneeModel } from 'src/app/models/tournee.model';
import { MathService } from 'src/app/services/math/math.service';

@Component({
  selector: 'basket-item',
  templateUrl: './basket-item.component.html',
  styleUrls: ['./basket-item.component.scss'],
})
export class BasketItemComponent implements OnInit {
  @Input()
  title:string;

  @Input()
  mode:string // edit, view, order, catalog, sale

  @Input()
  product:ProductModel;

  @Input()
  order:OrderModel;

  @Input()
  tournee:TourneeModel;

  constructor(public mathService:MathService) 
  {
    console.log('order',this.order);
  }

  ngOnInit(){
  }

}
